export const getESPWithoutCancelBtn = () => {
  return ['cordial', 'epsilon', 'responsys', 'braze', 'emarsys']
}
